import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/comfortaa/400.css";
import "@fontsource/comfortaa/700.css";

import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SuperUserProvider } from "./context/SuperUserContext";
import { PermissionsProvider } from "./context/PermissionsContext";
import { DashboardLayout } from "./components/layout/DashboardLayout";
import { RouteGuard } from "./components/layout/RouteGuard";
import { Toaster } from "./components/ui/sonner";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import InventoryPage from "./pages/InventoryPage";
import MedicationsPage from "./pages/MedicationsPage";
import PurchasesPage from "./pages/PurchasesPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProductsPage from "./pages/ProductsPage";
import DispatchesPage from "./pages/DispatchesPage";
import ReportsPage from "./pages/ReportsPage";
import SettingsPage from "./pages/SettingsPage";
import OperationalCostsPage from "./pages/OperationalCostsPage";
import UsersPage from "./pages/UsersPage";

function App() {
  return (
    <AuthProvider>
      <PermissionsProvider>
        <SuperUserProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected Routes */}
            <Route path="/" element={<DashboardLayout><RouteGuard permission="dashboard"><DashboardPage /></RouteGuard></DashboardLayout>} />
            <Route path="/inventory" element={<DashboardLayout><InventoryPage /></DashboardLayout>} />
            <Route path="/medications" element={<DashboardLayout><MedicationsPage /></DashboardLayout>} />
            <Route path="/purchases" element={<DashboardLayout><PurchasesPage /></DashboardLayout>} />
            <Route path="/projects" element={<DashboardLayout><ProjectsPage /></DashboardLayout>} />
            <Route path="/products" element={<DashboardLayout><ProductsPage /></DashboardLayout>} />
            <Route path="/dispatches" element={<DashboardLayout><DispatchesPage /></DashboardLayout>} />
            <Route path="/reports" element={<DashboardLayout><ReportsPage /></DashboardLayout>} />
            <Route path="/operational-costs" element={<DashboardLayout><OperationalCostsPage /></DashboardLayout>} />
            <Route path="/settings" element={<DashboardLayout><RouteGuard permission="settings"><SettingsPage /></RouteGuard></DashboardLayout>} />
            <Route path="/users" element={<DashboardLayout><RouteGuard permission="users"><UsersPage /></RouteGuard></DashboardLayout>} />
            
            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        </SuperUserProvider>
      </PermissionsProvider>
    </AuthProvider>
  );
}

export default App;
